export const creditFlags = [
  'credit_spot_offer_payment_method_boleto',
  'credit_spot_offers_module_web',
  'credit_bff_renegotiation_new_ccb_web_stone',
  'credit_bff_building_transparency_stone',
  'credit_bff_building_education_stone'
] as const
